import React from "react";
const LoginSideImage = () => {
  return (
    <svg
      width="440"
      height="440"
      viewBox="0 0 440 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_500_1055)">
        <path
          d="M105.614 65.6104H77.0098V94.2145H105.614V65.6104Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M91.3122 70.4971V89.3269"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M81.9318 79.9141H100.459"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M329.726 166.37C335.572 169.902 342.396 171.308 349.054 172.764C355.711 174.221 362.523 175.861 368.135 179.759C373.748 183.658 377.971 190.353 377.051 197.171C376.034 204.714 369.339 210.077 362.718 213.714C356.635 217.056 350.064 219.735 344.927 224.424C339.791 229.114 336.322 236.583 338.685 243.157C340.291 247.626 344.19 250.777 347.915 253.684C351.641 256.59 355.547 259.726 357.178 264.186C358.81 268.646 357.005 274.732 352.435 275.869"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M329.558 155.887C335.34 163.768 345.206 167.528 354.816 168.94C364.426 170.351 374.234 169.822 383.853 171.165C393.473 172.509 403.369 176.116 409.312 183.874C413.921 189.89 415.481 198.795 411.359 205.162C408.823 209.078 404.603 211.512 400.422 213.529C396.242 215.545 391.851 217.353 388.431 220.509C385.011 223.665 382.723 228.6 384.114 233.063C385.183 236.491 388.113 238.914 390.405 241.664C398.272 251.101 398.328 266.263 390.53 275.759"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M269.816 418.132C313.103 418.132 348.195 408.879 348.195 397.464C348.195 386.049 313.103 376.796 269.816 376.796C226.528 376.796 191.436 386.049 191.436 397.464C191.436 408.879 226.528 418.132 269.816 418.132Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M332.654 34.4967C332.654 32.838 332.327 31.1956 331.692 29.6632C331.057 28.1308 330.127 26.7384 328.954 25.5656C327.781 24.3927 326.389 23.4624 324.856 22.8276C323.324 22.1929 321.682 21.8662 320.023 21.8662H145.625C143.966 21.8662 142.324 22.1929 140.791 22.8276C139.259 23.4624 137.866 24.3927 136.694 25.5656C135.521 26.7384 134.59 28.1308 133.956 29.6632C133.321 31.1956 132.994 32.838 132.994 34.4967V35.9541H332.654V34.4967Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M132.994 35.9541V172.37C132.994 174.029 133.321 175.671 133.956 177.204C134.59 178.736 135.521 180.128 136.694 181.301C137.866 182.474 139.259 183.404 140.791 184.039C142.324 184.674 143.966 185.001 145.625 185.001H320.023C321.682 185.001 323.324 184.674 324.857 184.039C326.389 183.404 327.781 182.474 328.954 181.301C330.127 180.128 331.057 178.736 331.692 177.204C332.327 175.671 332.654 174.029 332.654 172.37V35.9541H132.994Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M223.959 99.5547V101.536H221.978"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M217.897 101.536H154.627"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.08 4.08"
        />
        <path
          d="M152.585 101.536H150.604V99.5547"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M150.604 95.7885V52.4521"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="3.77 3.77"
        />
        <path
          d="M150.604 50.5679V48.5869H152.585"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M156.667 48.5869H219.937"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.08 4.08"
        />
        <path
          d="M221.978 48.5869H223.959V50.5679"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M223.958 54.335V97.6713"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="3.77 3.77"
        />
        <path
          d="M315.045 168.611V170.592H313.064"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M308.981 170.593H245.712"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.08 4.08"
        />
        <path
          d="M243.671 170.592H241.69V168.611"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M241.69 164.539V52.6006"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.07 4.07"
        />
        <path
          d="M241.69 50.5679V48.5869H243.671"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M247.753 48.5869H311.022"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.08 4.08"
        />
        <path
          d="M313.064 48.5869H315.045V50.5679"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M315.044 54.6357V166.574"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.07 4.07"
        />
        <path
          d="M311.477 51.2812H245.257V167.899H311.477V51.2812Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M223.959 168.611V170.592H221.978"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M217.897 170.593H154.627"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.08 4.08"
        />
        <path
          d="M152.585 170.592H150.604V168.611"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M150.604 164.575V118.166"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.04 4.04"
        />
        <path
          d="M150.604 116.15V114.169H152.585"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M156.667 114.169H219.937"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.08 4.08"
        />
        <path
          d="M221.978 114.169H223.959V116.15"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M223.958 120.183V166.592"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4.04 4.04"
        />
        <path
          d="M220.343 116.951H154.221V167.813H220.343V116.951Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M203.434 98.9456C194.044 103.317 185.621 108.339 185.621 108.339C185.621 108.339 177.202 103.317 167.811 98.9456C158.417 94.5741 158.581 90.1208 158.581 90.1208V54.2524C158.581 44.862 172.667 42.2725 172.667 42.2725H198.576C198.576 42.2725 212.665 44.862 212.665 54.2524V90.1208C212.665 90.1208 212.825 94.5741 203.434 98.9456Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M185.621 101.65C182.282 99.7598 176.509 96.6051 170.256 93.6939C165.995 91.7115 164.702 90.0371 164.373 89.4966V54.2521C164.373 50.8122 170.886 48.6344 173.279 48.0645H197.967C200.333 48.6261 206.872 50.8059 206.872 54.2521V89.4946C206.544 90.0356 205.25 91.711 200.99 93.6941C194.736 96.6053 188.962 99.76 185.621 101.65Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M195.581 69.8393V66.2262C195.582 64.7648 195.295 63.3175 194.737 61.9671C194.178 60.6166 193.359 59.3894 192.326 58.3556C191.293 57.3218 190.067 56.5018 188.717 55.9422C187.367 55.3827 185.92 55.0947 184.458 55.0947C182.997 55.0947 181.55 55.3827 180.2 55.9422C178.85 56.5018 177.623 57.3218 176.59 58.3556C175.557 59.3894 174.738 60.6166 174.18 61.9671C173.621 63.3175 173.335 64.7648 173.336 66.2262V69.8393C173.336 70.3815 173.551 70.9015 173.935 71.2849C174.318 71.6683 174.838 71.8837 175.38 71.8837C175.922 71.8837 176.442 71.6683 176.826 71.2849C177.209 70.9015 177.425 70.3815 177.425 69.8393L177.424 66.2262C177.425 64.3613 178.167 62.573 179.486 61.2546C180.805 59.9362 182.593 59.1955 184.458 59.1955C186.323 59.1955 188.112 59.9362 189.431 61.2546C190.75 62.573 191.491 64.3613 191.492 66.2262V69.8393C191.492 70.3815 191.708 70.9015 192.091 71.2849C192.474 71.6683 192.994 71.8837 193.537 71.8837C194.079 71.8837 194.599 71.6683 194.982 71.2849C195.365 70.9015 195.581 70.3815 195.581 69.8393H195.581Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M151.941 32.1517C154.087 32.1517 155.827 30.4117 155.827 28.2653C155.827 26.1189 154.087 24.3789 151.941 24.3789C149.795 24.3789 148.055 26.1189 148.055 28.2653C148.055 30.4117 149.795 32.1517 151.941 32.1517Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M166.514 32.1517C168.66 32.1517 170.4 30.4117 170.4 28.2653C170.4 26.1189 168.66 24.3789 166.514 24.3789C164.368 24.3789 162.628 26.1189 162.628 28.2653C162.628 30.4117 164.368 32.1517 166.514 32.1517Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M181.089 32.1517C183.235 32.1517 184.975 30.4117 184.975 28.2653C184.975 26.1189 183.235 24.3789 181.089 24.3789C178.942 24.3789 177.202 26.1189 177.202 28.2653C177.202 30.4117 178.942 32.1517 181.089 32.1517Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.2408 373.197H345.034C380.721 364.363 383.726 331.967 371.652 311.363C361.305 293.704 342.594 284.034 313.971 294.003C289.112 265.052 247.599 251.79 210.651 260.388C171.715 269.448 154.581 298.888 151.9 303.688C144.619 295.684 120.878 271.098 101.253 275.201C79.602 279.728 65.8419 318.568 74.2408 373.197Z"
          stroke="#1A1A1A"
          stroke-width="0.990587"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M100.502 373.272H332.109C341.446 358.707 340.749 341.256 331.403 330.905C323.986 322.69 313.504 321.585 310.219 321.372C307.704 314.38 301.51 300.721 287.624 292.774C265.745 280.253 233.445 286.874 209.951 311.133C206.77 299.523 194.874 293.197 184.883 296.305C176.547 298.898 170.675 307.706 171.467 317.488C150.019 303.209 122.447 306.648 107.564 323.49C96.107 336.454 93.4424 355.918 100.502 373.272Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M47.5442 373.272H371.652"
          stroke="#1A1A1A"
          stroke-width="0.990587"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M272.844 379.454C271.987 377.652 271.148 376.273 271.148 376.273L259.144 379.686C259.144 379.686 258.286 380.473 256.99 381.741C261.583 384.389 268.193 382.594 272.844 379.454Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M256.99 381.741C252.632 386.002 243.303 395.712 244.845 399.34C246.846 404.048 253.907 401.047 258.85 397.81C263.793 394.574 274.973 388.219 274.62 384.806C274.45 383.163 273.639 381.126 272.844 379.454C268.193 382.594 261.583 384.389 256.99 381.741Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M295.469 380.69C295.215 378.742 294.999 377.432 294.999 377.432L283.937 379.55C283.232 380.428 282.581 381.348 281.986 382.304C285.964 385.4 291.839 383.711 295.469 380.69Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M295.469 380.692C291.839 383.713 285.964 385.402 281.986 382.306C281.143 383.652 280.23 385.351 279.7 387.084C278.523 390.928 273.031 407.875 278.131 409.209C283.23 410.542 290.056 406.07 291.861 400.029C293.665 393.988 296.49 392.889 296.176 387.79C296.019 385.236 295.724 382.644 295.469 380.692ZM240.472 218.988C240.472 218.988 213.129 263.827 213.835 282.539C214.541 301.251 253.966 379.159 257.967 381.042C261.969 382.925 269.736 379.748 272.325 377.394C274.914 375.04 270.56 363.154 268.677 357.387C266.794 351.621 258.83 317.335 246.748 298.191C257.104 283.441 268.716 263.984 270.442 249.704C272.168 235.425 273.639 217.455 273.639 217.455"
          fill="white"
        />
        <path
          d="M240.472 218.988C240.472 218.988 213.129 263.827 213.835 282.539C214.541 301.251 253.966 379.159 257.967 381.042C261.969 382.925 269.736 379.748 272.325 377.394C274.914 375.04 270.56 363.154 268.677 357.387C266.794 351.621 258.83 317.335 246.748 298.191C257.104 283.441 268.716 263.984 270.442 249.704C272.168 235.425 273.639 217.455 273.639 217.455M295.469 380.692C291.839 383.713 285.964 385.402 281.986 382.306C281.143 383.652 280.23 385.351 279.7 387.084C278.523 390.928 273.031 407.875 278.131 409.209C283.23 410.542 290.056 406.07 291.861 400.029C293.665 393.988 296.49 392.889 296.176 387.79C296.019 385.236 295.724 382.644 295.469 380.692Z"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M265.263 243.269C265.263 243.269 274.151 297.719 277.239 311.998C278.287 329.886 280.17 376.647 281.582 379.315C282.994 381.982 294.763 384.336 296.646 376.019C298.529 367.703 303.236 346.519 301.824 325.964C301.04 308.86 307.787 291.756 309.356 285.166C310.925 278.575 320.968 235.58 307.159 213.612L263.537 214.24"
          fill="white"
        />
        <path
          d="M265.263 243.269C265.263 243.269 274.151 297.719 277.239 311.998C278.287 329.886 280.17 376.647 281.582 379.315C282.994 381.982 294.763 384.336 296.646 376.019C298.529 367.703 303.236 346.519 301.824 325.964C301.04 308.86 307.787 291.756 309.356 285.166C310.925 278.575 320.968 235.58 307.159 213.612L263.537 214.24"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.497 226.048C269.853 225.56 275.385 227.364 280.681 226.824C285.976 226.284 306.639 224.584 309.528 218.079C307.709 212.514 241.256 217.454 241.256 217.454L238.072 223.044C238.072 223.044 239.726 228.52 259.497 226.048Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M241.099 187.879C241.099 187.879 241.884 199.961 239.373 205.61C236.863 211.259 234.195 224.126 244.708 223.812C255.222 223.499 265.794 222.117 272.031 223.818C278.269 225.519 305.042 222.753 309.75 214.28C314.457 205.806 318.341 178.385 317.164 172.501C315.987 166.617 310.729 138.607 300.589 136.254C290.449 133.9 253.496 138.607 253.496 138.607"
          fill="url(#paint0_linear_500_1055)"
        />
        <path
          d="M241.099 187.879C241.099 187.879 241.884 199.961 239.373 205.61C236.863 211.259 234.195 224.126 244.708 223.812C255.222 223.499 265.794 222.117 272.031 223.818C278.269 225.519 305.042 222.753 309.75 214.28C314.457 205.806 318.341 178.385 317.164 172.501C315.987 166.617 310.729 138.607 300.589 136.254C290.449 133.9 253.496 138.607 253.496 138.607"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M268.672 186.029C303.625 196.033 321.871 177.68 324.225 157.438C326.579 137.196 308.808 128.722 302.571 125.192C296.333 121.661 289.86 119.896 279.386 120.131C268.912 120.367 259.301 121.661 259.301 121.661C259.301 121.661 224.623 134.842 222.897 167.01C221.171 199.177 259.772 196.196 278.602 179.249C289.743 170.776 289.272 171.501 289.978 168.677C290.684 165.852 292.449 151.73 286.683 155.202C280.916 158.673 270.795 172.384 253.142 170.972L245.375 169.442C245.375 169.442 243.668 169.795 244.198 168.794C244.728 167.794 247.758 166.058 248.17 164.234C248.582 162.41 248.817 159.203 246.728 158.997C247.699 157.879 250.053 158.467 252.76 160.203C255.467 161.939 267.147 165.872 271.109 166.578"
          fill="#A0FF77"
        />
        <path
          d="M268.672 186.029C303.625 196.033 321.871 177.68 324.225 157.438C326.579 137.196 308.808 128.722 302.571 125.192C296.333 121.661 289.86 119.896 279.386 120.131C268.912 120.367 259.301 121.661 259.301 121.661C259.301 121.661 224.623 134.842 222.897 167.01C221.171 199.177 259.772 196.196 278.602 179.249C289.743 170.776 289.272 171.501 289.978 168.677C290.684 165.852 292.449 151.73 286.683 155.202C280.916 158.673 270.795 172.384 253.142 170.972L245.375 169.442C245.375 169.442 243.668 169.795 244.198 168.794C244.728 167.794 247.758 166.058 248.17 164.234C248.582 162.41 248.817 159.203 246.728 158.997C247.699 157.879 250.053 158.467 252.76 160.203C255.467 161.939 267.147 165.872 271.109 166.578"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M276.875 112.167C257.182 112.089 268.402 87.139 268.402 87.139L286.055 86.5898L290.448 99.3784L286.368 106.675C286.368 106.675 283.779 109.735 284.407 114.442C285.035 119.15 290.448 124.877 290.448 124.877C290.448 124.877 279.621 131.075 266.44 124.485C268.402 119.934 270.52 115.619 270.96 111.112"
          fill="white"
        />
        <path
          d="M276.875 112.167C257.182 112.089 268.402 87.139 268.402 87.139L286.055 86.5898L290.448 99.3784L286.368 106.675C286.368 106.675 283.779 109.735 284.407 114.442C285.035 119.15 290.448 124.877 290.448 124.877C290.448 124.877 279.621 131.075 266.44 124.485C268.402 119.934 270.52 115.619 270.96 111.112"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M270.667 113.064C270.667 113.064 275.698 113.137 276.875 112.166C272.55 111.946 270.903 111.329 270.903 111.329L270.667 113.064ZM262.38 77.233C262.38 77.4096 256.79 91.2965 273.149 91.4731C278.68 91.6496 279.857 90.767 281.034 89.4136C282.21 88.0602 284.741 90.9435 282.858 93.003C284.917 93.5914 287.036 92.8853 286.977 96.8866C286.918 100.888 283.799 101.3 282.564 101.653C283.976 105.89 285.8 107.831 287.271 107.831C290.448 107.184 291.213 107.243 292.331 99.7111C293.449 92.1792 295.215 87.766 290.448 83.1173C286.153 78.8806 282.637 77.7038 277.834 78.9983C273.031 80.2929 269.147 81.5874 263.734 76.5269C262.557 75.5854 262.38 77.233 262.38 77.233Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M289.978 168.677C303.159 164.146 300.335 145.904 300.335 145.904L289.978 168.677Z"
          fill="#A0FF77"
        />
        <path
          d="M289.978 168.677C303.159 164.146 300.335 145.904 300.335 145.904"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M247.061 160.613C247.061 160.613 241.059 157.828 235.606 160.966C230.153 164.105 230.35 169.44 232.193 171.597C234.037 173.755 238.313 171.44 239.568 170.381C240.824 169.322 241.255 168.537 242.04 168.459C242.824 168.38 245.688 168.655 245.688 168.655C245.688 168.655 248.966 165.963 249.885 162.653C250.278 161.241 247.061 160.613 247.061 160.613Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M198.286 68.3477H170.629V88.0013H198.286V68.3477Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M289.978 156.3C289.978 156.3 295.283 153.514 300.06 156.339C296.883 165.677 294.268 167.055 293.43 167.166L290.292 165.793C291.334 162.81 291.109 159.626 289.978 156.3Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M289.899 233.228C289.899 233.228 293.508 244.525 305.59 245.938"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M81.9449 142.653V135.223H74.2801C73.9804 134.138 73.548 133.093 72.9925 132.114L78.4117 126.695L73.1573 121.44L67.7381 126.859C66.7584 126.304 65.714 125.871 64.6284 125.572V117.91H57.2023V125.572C56.1167 125.871 55.0722 126.304 54.0926 126.859L48.6734 121.44L43.419 126.695L48.8382 132.114C48.2827 133.093 47.8503 134.138 47.5506 135.223H39.8858V142.653H47.5506C47.8502 143.738 48.2827 144.783 48.8382 145.762L43.419 151.182L48.6734 156.436L54.0926 151.017C55.0722 151.572 56.1167 152.005 57.2023 152.304V159.966H64.6284V152.304C65.714 152.005 66.7584 151.572 67.7381 151.017L73.1572 156.436L78.4117 151.182L72.9925 145.762C73.548 144.783 73.9804 143.738 74.2801 142.653H81.9449ZM67.3481 142.653C66.6959 143.782 65.7579 144.72 64.6284 145.373C64.0671 145.699 63.4645 145.949 62.8366 146.115C61.5767 146.452 60.2506 146.452 58.9907 146.115C58.3639 145.949 57.7624 145.699 57.2023 145.373C55.497 144.385 54.2512 142.763 53.7363 140.861C53.5709 140.233 53.4873 139.587 53.4875 138.938C53.4867 138.289 53.5715 137.642 53.7396 137.015C53.9059 136.387 54.1558 135.785 54.4826 135.223C55.1357 134.095 56.0735 133.157 57.2023 132.504C57.7624 132.177 58.3639 131.927 58.9907 131.761C60.2506 131.425 61.5767 131.425 62.8366 131.761C63.4645 131.927 64.0671 132.177 64.6284 132.504C65.7572 133.157 66.695 134.095 67.3481 135.223C67.6749 135.785 67.9248 136.387 68.091 137.015C68.2592 137.642 68.3439 138.289 68.3432 138.938C68.3434 139.587 68.2598 140.233 68.0944 140.861C67.9255 141.488 67.6746 142.091 67.3481 142.653Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M90.8422 226.198C102.588 226.198 112.11 216.676 112.11 204.93C112.11 193.184 102.588 183.662 90.8422 183.662C79.0964 183.662 69.5746 193.184 69.5746 204.93C69.5746 216.676 79.0964 226.198 90.8422 226.198Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M76.8892 204.434L89.2069 215.261C89.4669 215.49 89.7719 215.661 90.1022 215.765C90.4325 215.868 90.7808 215.901 91.1246 215.861C91.4685 215.822 91.8002 215.711 92.0984 215.535C92.3967 215.359 92.6548 215.123 92.8561 214.842L112.353 187.577C112.734 187.043 112.888 186.379 112.78 185.732C112.673 185.084 112.312 184.506 111.778 184.124C111.244 183.742 110.58 183.588 109.933 183.695C109.285 183.803 108.707 184.163 108.324 184.697L90.4199 209.734L80.1589 200.714C79.6655 200.281 79.0204 200.062 78.3653 200.104C77.7102 200.147 77.0988 200.448 76.6655 200.941C76.2321 201.434 76.0122 202.079 76.0542 202.734C76.0962 203.389 76.3966 204 76.8893 204.434L76.8892 204.434Z"
          fill="#00394D"
        />
        <path
          d="M155.004 323.646C151.631 320.5 147.912 316.547 148.702 312.003C149.299 308.574 152.287 306.175 154.398 303.408C157.317 299.582 158.68 294.487 157.578 289.803C156.475 285.119 152.75 281.029 148.063 279.94C143.376 278.852 137.99 281.109 135.858 285.423C134.188 288.804 134.567 292.779 134.222 296.535C133.878 300.29 132.269 304.505 128.669 305.627C125.662 306.564 122.477 304.955 119.913 303.127C117.348 301.298 114.803 299.116 111.679 298.715C108.012 298.245 104.345 300.521 102.488 303.718C100.632 306.914 100.373 310.84 101.024 314.479C101.675 318.117 103.166 321.544 104.644 324.932L94.9232 336.068L91.7331 373.2H125.132C128.576 371.645 131.791 369.602 134.983 367.567C137.62 365.885 140.257 364.203 142.894 362.521C144.678 361.383 146.657 359.929 146.776 357.816C147.017 353.53 139.717 351.872 139.837 347.582C139.886 345.833 141.299 344.364 142.909 343.679C144.519 342.995 146.312 342.928 148.058 342.817C150.734 342.646 153.458 342.33 155.889 341.2C158.321 340.071 160.447 337.997 161.024 335.379C162.016 330.875 158.377 326.791 155.004 323.646Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M140.867 302.883C140.867 302.883 137.335 323.416 126.356 333.518C115.378 343.619 113.49 357.151 113.962 363.13C114.434 369.108 108.927 373.199 108.927 373.199M128.122 354.319C128.122 354.319 118.27 350.93 114.228 356.872M115.378 328.181C115.378 328.181 120.037 330.443 119.753 341.516M141.968 323.323C141.968 323.323 138.643 328.175 130.314 329.053"
          stroke="white"
          stroke-width="0.990587"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M106.62 364.638C110.086 357.836 106.601 352.437 100.844 348.686C95.1572 343.398 99.4441 339.928 104.502 336.713C113.591 328.776 104.546 314.317 93.4219 319.067C89.4247 321.002 84.7833 326.551 80.1215 323.307C77.4427 321.186 78.327 317.047 78.6133 313.642C79.5035 305.103 73.0659 292.931 63.3278 294.494C58.9905 295.58 56.5188 300.256 52.4837 302.182C40.5608 307.36 31.3123 290.577 19.6897 291.669C-2.84278 296.722 4.30564 336.121 36.5779 331.256C39.1564 331.469 41.8537 332.444 43.2946 334.592C47.9792 341.942 35.9933 350.644 40.4724 358.026C44.3773 363.638 52.1298 360.742 57.8007 360.625C65.7578 360.38 68.9325 367.327 64.5322 373.198H95.4417C100.076 371.623 104.257 369.096 106.62 364.638Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M75.0589 373.198L77.537 368.478C88.3934 330.952 31.5152 311.363 31.5152 311.363M82.7292 338.976C82.7292 338.976 84.033 347.349 78.1496 352.249L82.7292 338.976ZM58.7349 311.363C58.8922 311.757 63.5091 319.498 59.7453 326.72L58.7349 311.363ZM59.2856 338.191C59.2856 338.191 69.2305 337.039 72.8331 340.25L59.2856 338.191ZM34.0326 317.185C34.0326 317.185 39.4523 318.922 44.3341 317.031L34.0326 317.185Z"
          fill="white"
        />
        <path
          d="M75.0589 373.198L77.537 368.478C88.3934 330.952 31.5152 311.363 31.5152 311.363M82.7292 338.976C82.7292 338.976 84.033 347.349 78.1496 352.249M58.7349 311.363C58.8922 311.757 63.5091 319.498 59.7453 326.72M59.2856 338.191C59.2856 338.191 69.2305 337.039 72.8331 340.25M34.0326 317.185C34.0326 317.185 39.4523 318.922 44.3341 317.031"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M381.11 278.782H341.278V282.612H381.11V278.782Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M381.11 282.612H341.278V318.426H381.11V282.612Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M381.11 318.428H341.278V373.29H381.11V318.428Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M381.11 272.062H341.278V278.784H381.11V272.062Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M348.71 296.571C349.337 296.571 349.845 296.063 349.845 295.437C349.845 294.81 349.337 294.302 348.71 294.302C348.083 294.302 347.575 294.81 347.575 295.437C347.575 296.063 348.083 296.571 348.71 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M357.435 296.571C358.062 296.571 358.57 296.063 358.57 295.437C358.57 294.81 358.062 294.302 357.435 294.302C356.808 294.302 356.3 294.81 356.3 295.437C356.3 296.063 356.808 296.571 357.435 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M366.159 296.571C366.785 296.571 367.293 296.063 367.293 295.437C367.293 294.81 366.785 294.302 366.159 294.302C365.532 294.302 365.024 294.81 365.024 295.437C365.024 296.063 365.532 296.571 366.159 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M374.882 296.571C375.509 296.571 376.017 296.063 376.017 295.437C376.017 294.81 375.509 294.302 374.882 294.302C374.255 294.302 373.747 294.81 373.747 295.437C373.747 296.063 374.255 296.571 374.882 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M366.159 310.647C366.785 310.647 367.293 310.139 367.293 309.513C367.293 308.886 366.785 308.378 366.159 308.378C365.532 308.378 365.024 308.886 365.024 309.513C365.024 310.139 365.532 310.647 366.159 310.647Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M374.882 310.647C375.509 310.647 376.017 310.139 376.017 309.513C376.017 308.886 375.509 308.378 374.882 308.378C374.255 308.378 373.747 308.886 373.747 309.513C373.747 310.139 374.255 310.647 374.882 310.647Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M374.882 324.176C375.509 324.176 376.017 323.668 376.017 323.041C376.017 322.414 375.509 321.906 374.882 321.906C374.255 321.906 373.747 322.414 373.747 323.041C373.747 323.668 374.255 324.176 374.882 324.176Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M367.293 322.105H347.575V323.978H367.293V322.105Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M374.882 335.355C375.509 335.355 376.017 334.847 376.017 334.221C376.017 333.594 375.509 333.086 374.882 333.086C374.255 333.086 373.747 333.594 373.747 334.221C373.747 334.847 374.255 335.355 374.882 335.355Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M367.293 333.282H347.575V335.155H367.293V333.282Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M374.882 346.532C375.509 346.532 376.017 346.024 376.017 345.397C376.017 344.771 375.509 344.263 374.882 344.263C374.255 344.263 373.747 344.771 373.747 345.397C373.747 346.024 374.255 346.532 374.882 346.532Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M367.293 344.459H347.575V346.331H367.293V344.459Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M374.882 357.709C375.509 357.709 376.017 357.201 376.017 356.574C376.017 355.947 375.509 355.439 374.882 355.439C374.255 355.439 373.747 355.947 373.747 356.574C373.747 357.201 374.255 357.709 374.882 357.709Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M367.293 355.639H347.575V357.511H367.293V355.639Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M424.772 278.782H384.94V282.612H424.772V278.782Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M424.771 318.428H384.94V373.29H424.771V318.428Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M424.771 282.612H384.94V318.426H424.771V282.612Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M424.772 272.062H384.94V278.784H424.772V272.062Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M392.372 296.571C392.999 296.571 393.507 296.063 393.507 295.437C393.507 294.81 392.999 294.302 392.372 294.302C391.745 294.302 391.237 294.81 391.237 295.437C391.237 296.063 391.745 296.571 392.372 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M401.097 296.571C401.724 296.571 402.232 296.063 402.232 295.437C402.232 294.81 401.724 294.302 401.097 294.302C400.47 294.302 399.962 294.81 399.962 295.437C399.962 296.063 400.47 296.571 401.097 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M409.821 296.571C410.447 296.571 410.955 296.063 410.955 295.437C410.955 294.81 410.447 294.302 409.821 294.302C409.194 294.302 408.686 294.81 408.686 295.437C408.686 296.063 409.194 296.571 409.821 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M418.544 296.571C419.171 296.571 419.679 296.063 419.679 295.437C419.679 294.81 419.171 294.302 418.544 294.302C417.917 294.302 417.409 294.81 417.409 295.437C417.409 296.063 417.917 296.571 418.544 296.571Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M409.821 310.647C410.447 310.647 410.955 310.139 410.955 309.513C410.955 308.886 410.447 308.378 409.821 308.378C409.194 308.378 408.686 308.886 408.686 309.513C408.686 310.139 409.194 310.647 409.821 310.647Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M418.544 310.647C419.171 310.647 419.679 310.139 419.679 309.513C419.679 308.886 419.171 308.378 418.544 308.378C417.917 308.378 417.409 308.886 417.409 309.513C417.409 310.139 417.917 310.647 418.544 310.647Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M418.544 324.176C419.171 324.176 419.679 323.668 419.679 323.041C419.679 322.414 419.171 321.906 418.544 321.906C417.917 321.906 417.409 322.414 417.409 323.041C417.409 323.668 417.917 324.176 418.544 324.176Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M410.954 322.105H391.237V323.978H410.954V322.105Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M418.544 335.355C419.171 335.355 419.679 334.847 419.679 334.221C419.679 333.594 419.171 333.086 418.544 333.086C417.917 333.086 417.409 333.594 417.409 334.221C417.409 334.847 417.917 335.355 418.544 335.355Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M410.954 333.282H391.237V335.155H410.954V333.282Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M418.544 346.532C419.171 346.532 419.679 346.024 419.679 345.397C419.679 344.771 419.171 344.263 418.544 344.263C417.917 344.263 417.409 344.771 417.409 345.397C417.409 346.024 417.917 346.532 418.544 346.532Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M410.954 344.459H391.237V346.331H410.954V344.459Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M418.544 357.709C419.171 357.709 419.679 357.201 419.679 356.574C419.679 355.947 419.171 355.439 418.544 355.439C417.917 355.439 417.409 355.947 417.409 356.574C417.409 357.201 417.917 357.709 418.544 357.709Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M410.954 355.639H391.237V357.511H410.954V355.639Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M424.772 373.29H433.401V280.699L424.772 272.062V373.29Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M395.936 184.251C409.347 184.251 420.219 173.379 420.219 159.967C420.219 146.556 409.347 135.684 395.936 135.684C382.524 135.684 371.652 146.556 371.652 159.967C371.652 173.379 382.524 184.251 395.936 184.251Z"
          fill="#03151C"
          stroke="#1A1A1A"
          stroke-width="0.330147"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M398.194 155.657C399.047 155.16 399.712 154.396 400.087 153.484C400.461 152.571 400.525 151.561 400.268 150.608C400.011 149.656 399.447 148.815 398.664 148.215C397.88 147.615 396.921 147.29 395.935 147.29C394.948 147.29 393.989 147.615 393.206 148.215C392.423 148.815 391.859 149.656 391.602 150.608C391.344 151.561 391.408 152.571 391.783 153.484C392.158 154.396 392.823 155.16 393.675 155.657C391.718 156.159 389.984 157.298 388.745 158.894C387.507 160.491 386.834 162.454 386.834 164.474V168.87H405.035V164.474C405.035 162.454 404.363 160.491 403.124 158.894C401.886 157.298 400.151 156.159 398.194 155.657Z"
          fill="white"
          stroke="#1A1A1A"
          stroke-width="0.660293"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_500_1055"
          x1="276.998"
          y1="124.501"
          x2="277.24"
          y2="224.296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3EC006" />
          <stop offset="1" stop-color="#A0FF77" />
        </linearGradient>
        <clipPath id="clip0_500_1055">
          <rect width="440" height="440" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default LoginSideImage;
